// Disable max class per file due to form validation classes
/* eslint-disable max-classes-per-file */

import { IsArray, IsEnum, IsInt, IsNotEmpty, IsNumber, IsOptional, IsString, ValidateIf, ValidateNested } from 'class-validator';
import { DomainApiModel } from '../../../../types/models/domain.model';
import { AttributeEntryType } from '../../../../types/constants/attribute-entry-type';
import { AttributeType } from '../../../../types/constants/attribute-type';

class DomainForm implements Pick<DomainApiModel, keyof DomainForm> {
  @IsInt()
  id: number;

  @IsString()
  name: string;

  @IsString()
  shortName: string;
}

export class AttributeForm {
  @IsString()
  @IsNotEmpty()
  name: string;

  @IsString()
  @IsOptional()
  description?: string | null;

  @ValidateIf((form: AttributeForm) => form.type === AttributeType.INTEGER || form.type === AttributeType.DOUBLE)
  @IsOptional()
  @IsNumber()
  minimumValue?: number | null;

  @ValidateIf((form: AttributeForm) => form.type === AttributeType.INTEGER || form.type === AttributeType.DOUBLE)
  @IsOptional()
  @IsNumber()
  maximumValue?: number | null;

  @IsEnum(AttributeEntryType)
  entryType: AttributeEntryType;

  @IsEnum(AttributeType)
  type: AttributeType;

  @ValidateIf((form: AttributeForm) => form.type === AttributeType.DOUBLE)
  @IsInt()
  numberOfDecimals?: number | null;

  @IsOptional()
  defaultValue?: string | number | null;

  @ValidateIf((form: AttributeForm) => form.type === AttributeType.LIST)
  @IsArray()
  @IsString({ each: true })
  values?: string[] | null;

  @IsArray()
  @ValidateNested({ each: true })
  domains: DomainForm[];
}
